import { createAction, props } from '@ngrx/store';

import { JwtUser } from '@models/authentication/jwt-user.model';
import { ResetPassword } from '@app/shared/models/authentication/reset-password.model';

// Login
export const login = createAction(
  '[Auth] Login',
  props<{ payload: any }>()
);

export const loginSuccess = createAction(
  '[Auth] Login Success',
  props<{ data: JwtUser }>()
);

export const loginFailed = createAction(
  '[Auth] Login Failed',
  props<{ error: any }>()
);

// Refresh Token
export const refreshToken = createAction(
  '[Auth] Refresh Token'
);

export const refreshTokenSuccess = createAction(
  '[Auth] Refresh Token Success',
  props<{ data: JwtUser }>()
);

export const refreshTokenFailed = createAction(
  '[Auth] Refresh Token Failed',
  props<{ error: any }>()
);

// Logout
export const logout = createAction(
  '[Auth] Logout'
);

export const logoutSuccess = createAction(
  '[Auth] Logout Success'
);

export const logoutFailed = createAction(
  '[Auth] Logout Failed',
  props<{ error: any }>()
);

// Forgot Password
export const forgotPassword = createAction(
  '[Auth] Forgot Password',
  props<{ email: string }>()
);

export const forgotPasswordSuccess = createAction(
  '[Auth] Forgot Password Success'
);

export const forgotPasswordFailed = createAction(
  '[Auth] Forgot Password Failed',
  props<{ error: any }>()
);

// Reset Password
export const resetPassword = createAction(
  '[Auth] Reset Password',
  props<{ payload: ResetPassword }>()
);

export const resetPasswordSuccess = createAction(
  '[Auth] Reset Password Success'
);

export const resetPasswordFailed = createAction(
  '[Auth] Reset Password Failed',
  props<{ error: any }>()
);
